<template>
  <div id="app">
      <hello></hello>
  </div>
</template>

<script>
import Hello from './components/Hello'

export default {
  name: 'app',
  components: {
    Hello
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?1a80f06a